import { Navigate, Outlet } from "react-router-dom";
import { useGetProfileQuery } from "../../../redux/reducers/apiSlice";
import FullPageNexusLogoAnimation from "../../Reusable/FullPageNexusLogoAnimation/FullPageNexusLogoAnimation";

/**
 * Blocks Measure platform operators from the Ignite member application.
 */
const MemberAppRoute = () => {
  const { data: profile, isLoading } = useGetProfileQuery();

  if (isLoading) {
    return <FullPageNexusLogoAnimation />;
  }

  if (profile?.isMeasureAdmin) {
    return <Navigate to="/measure/internal" replace />;
  }

  return <Outlet />;
};

export default MemberAppRoute;
